module.exports = __webpack_public_path__ + "img/vuma-logo.bc3baa99.svg";